<template>
    <section
        :class="`support_notifications_postmenu border-right ${relative ? 'position-relative' : ''}`"
        :style="{ width }"
        ref="menu"
    >
        <el-drawer
            :direction="`ltr`"
            :visible.sync="relative ? true : openPostsMenu"
            :modal="false"
            custom-class=""
            @opened="setDrawerHeight"
            ref="draw"
        >
            <template v-slot:title>
        <span class="">
          <h5 class="m-0">{{ title }}</h5>
        </span>
            </template>

            <vue-scroll :ops="vueScrollOptions">
                <section :style="{ padding: '20px 20px' }" :class="`${relative ? '' : 'border-top'}`">
                    <div v-for="(group, date) in notificationsGroupedByDate" :key="date" class="mt-0 mb-5">
                        <h4 class="mb-2">{{ date }}</h4>

                        <div v-for="(e, i) in group" :key="e.id" @click="() => readPost(e)" class="mb-3">
                            <el-card
                                :class="[
                  'box-card',
                  e.read === 1 ? 'card-read' : 'card-unread bg-light',
                  activePostId === e.id ? 'card-active border-success' : 'card-inactive'
                ]"
                                shadow="hover"
                                :body-style="{ padding: '10px' }"
                            >
                                <div class="d-flex justify-content-between text-muted">
                                    <small class="">{{ e.notification.date | moment("DD/MM/YYYY, h:mm a") }}</small>
                                    <small class="">#{{ e.notification.id }}</small>
                                </div>
                                <div class="d-flex justify-content-between text-muted">
                                    <small>{{ e.notification.subject | trim(80) }}</small>
                                    <!-- <small>#{{ e.notification.id }}</small> -->
                                </div>
                            </el-card>
                        </div>
                    </div>
                </section>
            </vue-scroll>
        </el-drawer>
    </section>
</template>

<script>
import {mapGetters, mapState} from "vuex"
import {mapStore} from "@shared/lib/Helpers"

export default {
    components: {},
    props: {
        title: {type: String, default: "Posts"},
        relative: {type: Boolean, default: false},
        width: {type: String, default: "30%"}
    },
    data() {
        return {}
    },
    computed: {
        ...mapState(["vueScrollOptions", "activePostId"]),
        ...mapGetters(["notifications", "notificationsGroupedByDate", "height"]),
        ...mapStore(["openPostsMenu", "hidePost"])
    },
    watch: {
        height() {
            this.setDrawerHeight()
        },
        activePostId: {
            handler(activePostId) {
                let notification = this.notifications.find(notification => notification.id == activePostId)
                if (notification) {
                    if (!notification.read) {
                        this.$store.dispatch("openPostsMenu", false)
                        this.$store.dispatch("markAsRead", notification)
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        this.setDrawerHeight()
    },
    updated() {
    },
    activated() {
    },
    methods: {
        setDrawerHeight() {
            // console.log("setDrawerHeight()")
            // prettier-ignore
            $(this.$refs.menu).find(".el-drawer__wrapper").height(this.height.scrollable)
        },
        readPost(notification) {
            this.$store.dispatch("openPostsMenu", false)
            this.$store.dispatch("markAsRead", notification)
        }
    }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';

.box-card {
    &:hover {
        cursor: pointer;
    }

    &.card-active {
    }

    &.card-inactive {
    }

    &.card-read {
    }

    &.card-unread {
        * {
            font-weight: bold;
        }
    }
}
</style>

<style lang="scss">
.support_notifications_postmenu {
    .el-drawer__body {
        height: 0 !important;
    }

    &.position-relative {
        .el-drawer__wrapper {
            position: relative;
            width: 100%;
            height: 300px;
        }

        .el-drawer {
            width: 100% !important;
        }

        .el-drawer__header {
            display: none;
        }
    }
}
</style>
